import type { Workspace, WorkspaceMember } from "../models/workspace";

/**
 * Whether the developer-terms gate applies right now.
 *
 * Single home for the rule so it cannot be stated two ways: the route guards
 * ask this to decide whether to redirect to `/accept-terms`, and the terms page
 * itself asks it to decide whether the visitor belongs there at all. Those two
 * sites previously carried the same condition written as De Morgan duals, so a
 * future change to the rule (a grace period, another partner category) had two
 * places to get right.
 *
 * A workspace with no type, or an unrecognised one the schema mapped to null,
 * is not gated: the backend enforces the same rule with a 403, so this only
 * decides what the user is shown.
 *
 * Typed as a guard on `workspace` because gating implies a resolved Partner
 * workspace, which lets callers that early-return on the negated form keep
 * treating it as non-null afterwards.
 */
export function isPartnerTermsGated(
  workspace: Workspace | null | undefined,
  workspaceMember: WorkspaceMember | null | undefined,
): workspace is Workspace {
  return workspace?.type === "partner" && !workspaceMember?.acceptedTerms;
}
